<template>
  <ZtLink
    :to="home"
    data-testid="logo"
    class="text-prose leading-[0.8] font-bold tablet:hover:opacity-80"
    @click="trackClick"
  >
    <div
      class="relative grid grid-cols-1 grid-rows-1 pb-[0.25em] whitespace-nowrap"
    >
      <Transition name="logo">
        <div
          :key="top"
          class="col-start-1 row-start-1"
          :style="{
            color: `rgb(var(--color-${color}) / 1)`,
          }"
        >
          {{ top }}
        </div>
      </Transition>
    </div>
    <div
      class="logo-theme-bottom text-scheme-invert tablet:!text-scheme-invert [.has-hero-image_&]:text-white"
    >
      <div>{{ bottom }}</div>
    </div>
  </ZtLink>
</template>

<script lang="ts" setup>
const props = defineProps<{
  top: string
  color: string
  bottom: string
}>()

const emit = defineEmits(['click'])

const language = useCurrentLanguage()
const { trackEvent } = useAnalytics()

function trackClick() {
  trackEvent({
    event: 'click_navbar_element',
    element_name: 'Motto',
    element_id: 'brand-logo',
    element_url: 'home',
  })
  emit('click')
}

const home = computed(() => '/' + language.value)

// Enjoy (default on non-start pages) has no trailing comma.
// Welcome (start pages) and Logo theme overrides do.
const top = computed(() => {
  if (props.top === 'Enjoy') {
    return props.top
  }
  return `${props.top},`
})
</script>

<style>
@reference '~/assets/css/tailwind.css';
.logo-enter-active,
.logo-leave-active {
  @apply transition duration-[400ms];
  transition-timing-function: cubic-bezier(0.92, 0.14, 0.37, 1);
}

.logo-enter-from {
  @apply translate-y-[0.75em];
  opacity: 0;
}

.logo-leave-to {
  @apply translate-y-[-0.75em];
  opacity: 0;
}
</style>
